import { FC, lazy } from 'react';
import { PageSpinner } from 'src/components/spinner-container';
import { useConversionRequest } from 'src/pages/reporting/my-transactions/deals/conversions/details/use-conversion-request';
import { useCapacityManagementRoot } from 'src/pages/transport/network-points/details/availability-and-price-data/overview/use-capacity-management-root';

const Page = lazy(() => import('./page'));

export const ConversionDetail: FC = () => {
  const capacityManagementRoot = useCapacityManagementRoot();
  const conversionRequest = useConversionRequest({ capacityManagementRoot });

  if (!conversionRequest.response) return <PageSpinner />;
  return <Page conversionRequest={conversionRequest} />;
};
